import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { LiveAppId as AppId } from "@/lib/apps";
import type { PromptBankEntry } from "./types";

export const usePromptBank = (app: AppId | null | undefined) => {
  const [prompts, setPrompts] = useState<PromptBankEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!app) {
      setPrompts([]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    void supabase
      .from("profile_prompts")
      .select("id, app, prompt_key, prompt_text, sort_order")
      .eq("app", app)
      .eq("active", true)
      .order("sort_order", { ascending: true })
      .then(({ data }) => {
        if (cancelled) return;
        setPrompts((data as PromptBankEntry[]) ?? []);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [app]);

  return { prompts, loading };
};
